import { ref, update, onValue, get } from 'firebase/database'
import { db, tref } from './firebase.js'

// Suite settings. /club/settings — tax, taxonomy lists, notification templates.
const BASE = 'club/settings'
export const DEFAULT_SETTINGS = {
  taxRate: 0,
  departments: ['Apparel', 'Equipment', 'Accessories', 'Footwear', 'Balls', 'Food & Bev'],
  categories: ['Shirts', 'Outerwear', 'Hats', 'Gloves', 'Drivers', 'Irons', 'Putters', 'Wedges', 'Bags', 'Balls', 'Tees'],
  brands: ['Titleist', 'Callaway', 'TaylorMade', 'Ping', 'FootJoy', 'Cobra', 'Srixon', 'Bridgestone'],
  notificationTemplates: {
    orderIn: 'Hi [name], your order has arrived at the pro shop and is ready for pickup.',
    repairReady: 'Hi [name], your club repair is ready for pickup at the pro shop.',
    demoOverdue: 'Hi [name], a friendly reminder to return your demo club to the pro shop.',
  },
}

export function watchSettings(cb) {
  return onValue(tref(BASE), (s) => cb({ ...DEFAULT_SETTINGS, ...(s.val() || {}) }))
}
export async function getSettingsOnce() {
  return { ...DEFAULT_SETTINGS, ...((await get(tref(BASE))).val() || {}) }
}
export async function updateSettings(patch) { await update(tref(BASE), patch) }
